const initialState = {
  data: null as any,
  isFetching: false
};

const cast = (state: any = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_SHOWS':
      return {
        ...state,
        isFetching: true
      };
    case 'RECEIVE_SHOWS':
      return {
        ...state,
        isFetching: false,
        data: [...action.shows]
      };
    case 'RECEIVE_SHOWS_ERROR':
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
};

export default cast;
